import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import useTypedSelector from './useTypedSelector';
import useUserAgent from './useUserAgent';
import {Page} from '../constant/page';
import {actions, ActionType, getWebToAppBannerFetchkey} from '../state/action';
import {useFetchInfo} from '../util/fetch';

export default function useFetchWebToAppBanner() {
  const dispatch = useDispatch();
  const isViewerPage = useTypedSelector(
    state => state.common.layoutProps.page === Page.Viewer
  );
  const {isFirstFetched} = useFetchInfo(
    ActionType.FetchWebToAppBanner,
    getWebToAppBannerFetchkey(isViewerPage)
  );
  const userAgent = useUserAgent();

  useEffect(() => {
    userAgent &&
      userAgent.isMobile &&
      !userAgent.isWebView &&
      !isFirstFetched &&
      window.requestIdleCallback(() => {
        dispatch(actions.fetchWebToAppBanner(isViewerPage));
      });
  }, [isFirstFetched, dispatch, isViewerPage, userAgent]);
}
